import { render } from "./PenjadwalanGuru.vue?vue&type=template&id=768c3a4d"
import script from "./PenjadwalanGuru.vue?vue&type=script&lang=js"
export * from "./PenjadwalanGuru.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__